module.exports = __webpack_public_path__ + "img/OKIS-J-10.a46f96ac.svg";